import OrganizationForm from '@/components/organizations/OrganizationForm'
import { Head } from '@inertiajs/react'

export default function OrganizationNew() {
  return (
    <>
      <Head title="Nouvelle Organisation" />
      <OrganizationForm />
    </>
  )
}
